var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMailSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.293 14.293a1 1 0 011.414 0l3 3a.999.999 0 01.216 1.089 1.014 1.014 0 01-.216.326l-3 2.999A.993.993 0 0120 22a.999.999 0 01-.707-1.707L20.586 19H15a1 1 0 010-2h5.586l-1.293-1.293a.999.999 0 010-1.414zM21 3a3.004 3.004 0 012.995 2.824L24 6v6a1 1 0 01-1.993.116L22 12V6.564l-9.341 8.188a.996.996 0 01-1.22.076l-.098-.076L2 6.564V18c0 .512.387.935.884.993L3 19h8a1 1 0 01.117 1.993L11 21H3a3.004 3.004 0 01-2.995-2.824L0 18V6a3.004 3.004 0 012.824-2.995L3 3h18zm-.25 2H3.25L12 12.67 20.75 5z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconMailSend;